export const SAVE_STATE = 'hall/form/SAVE_STATE'
export const CLEAR_STATE = 'hall/form/CLEAR_STATE'
